var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backtop"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"icon",on:{"click":_vm.handleClick}},[_c('img',{attrs:{"src":require("@/assets/images/icon-返回顶部.png"),"alt":"BACKTOP"}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }